import { createSelector } from 'reselect';

import { RootState } from '../../configuration/setup/store';

export const selectLang = (state: RootState) => state.lang;
export const selectLocale = createSelector(selectLang, (state) => state.displayLocale);
export const selectDisplayMessages = createSelector(selectLang, (state) => state.displayMessages);
